import { render, staticRenderFns } from "./ContractorDashboard.vue?vue&type=template&id=60006964&scoped=true"
import script from "./ContractorDashboard.vue?vue&type=script&lang=js"
export * from "./ContractorDashboard.vue?vue&type=script&lang=js"
import style0 from "./ContractorDashboard.vue?vue&type=style&index=0&id=60006964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60006964",
  null
  
)

export default component.exports